"use client";

export default function ClassListingCardSkeleton() {
  return (
    <>
      <style>{`
        @keyframes shimmer {
          0% {
            background-position: -1000px 0;
          }
          100% {
            background-position: 1000px 0;
          }
        }

        .skeleton-shimmer {
          background: linear-gradient(
            90deg,
            #f0f0f0 0%,
            #e0e0e0 50%,
            #f0f0f0 100%
          );
          background-size: 1000px 100%;
          animation: shimmer 2s infinite;
        }
      `}</style>
        
        <main className="w-full px-0 py-10">
          <div className="grid grid-cols-1 gap-5 md:grid-cols-1 xl:grid-cols-2">
            {/* Skeleton Card 1 */}
            <div className="hidden md:block">
              <div className="relative rounded-[30px] border-2 border-gray-200 bg-white px-5 flex items-center w-full h-[300px] gap-4 overflow-hidden">
                <div className="relative w-[98px] md:w-[120px] xl:w-[98px] min-[1600px]:!w-[100px] h-[290px] flex items-start justify-start flex-col overflow-hidden rounded-lg skeleton-shimmer" />
                <div className="relative w-full xl:w-[400px] 2xl:w-[465px] min-[1600px]:!w-[80%] flex-1">
                  <div className="border-b border-gray-200 pb-3">
                    <div className="mb-2 h-8 w-48 rounded skeleton-shimmer" />
                    <div className="mb-2 h-4 w-32 rounded skeleton-shimmer" />
                    <div className="flex items-center gap-1 mt-3">
                      <div className="h-5 w-5 rounded-full skeleton-shimmer" />
                      <div className="h-4 w-40 rounded skeleton-shimmer" />
                    </div>
                  </div>
                  <div className="mt-4 grid grid-cols-12 gap-3">
                    <div className="col-span-5">
                      <div className="mb-2 h-3 w-24 rounded skeleton-shimmer" />
                      <div className="h-4 w-32 rounded skeleton-shimmer" />
                    </div>
                    <div className="col-span-4 border-l border-gray-200 pl-3">
                      <div className="mb-2 h-3 w-20 rounded skeleton-shimmer" />
                      <div className="h-4 w-28 rounded skeleton-shimmer" />
                    </div>
                    <div className="col-span-3 border-l border-gray-200 pl-3">
                      <div className="mb-2 h-3 w-16 rounded skeleton-shimmer" />
                      <div className="h-4 w-24 rounded skeleton-shimmer" />
                    </div>
                  </div>
                  <div className="mt-5 h-10 w-full rounded-full skeleton-shimmer" />
                </div>
              </div>
            </div>

            {/* Mobile Skeleton Card 1 */}
            <div className="block md:hidden">
              <div className="relative rounded-[30px] border-2 border-gray-200 bg-white px-4 w-full h-max gap-4 overflow-hidden py-4">
                <div className="relative flex items-center gap-4">
                  <div className="relative w-[120px] h-[290px] flex-shrink-0 rounded-lg skeleton-shimmer" />
                  <div className="relative w-full flex-1">
                    <div className="border-b border-gray-200 pb-3 mb-4">
                      <div className="mb-2 h-7 w-40 rounded skeleton-shimmer" />
                      <div className="mb-2 h-3 w-28 rounded skeleton-shimmer" />
                      <div className="flex items-center gap-1 mt-2">
                        <div className="h-4 w-4 rounded-full skeleton-shimmer" />
                        <div className="h-3 w-32 rounded skeleton-shimmer" />
                      </div>
                    </div>
                    <div className="space-y-3">
                      <div>
                        <div className="mb-1 h-2 w-20 rounded skeleton-shimmer" />
                        <div className="h-3 w-28 rounded skeleton-shimmer" />
                      </div>
                      <div>
                        <div className="mb-1 h-2 w-16 rounded skeleton-shimmer" />
                        <div className="h-3 w-24 rounded skeleton-shimmer" />
                      </div>
                      <div>
                        <div className="mb-1 h-2 w-12 rounded skeleton-shimmer" />
                        <div className="h-3 w-20 rounded skeleton-shimmer" />
                      </div>
                    </div>
                    <div className="mt-4 h-9 w-full rounded-full skeleton-shimmer" />
                  </div>
                </div>
              </div>
            </div>

            {/* Skeleton Card 2 */}
            <div className="hidden md:block">
              <div className="relative rounded-[30px] border-2 border-gray-200 bg-white px-5 flex items-center w-full h-[300px] gap-4 overflow-hidden">
                <div className="relative w-[98px] md:w-[120px] xl:w-[98px] min-[1600px]:!w-[100px] h-[290px] flex items-start justify-start flex-col overflow-hidden rounded-lg skeleton-shimmer" />
                <div className="relative w-full xl:w-[400px] 2xl:w-[465px] min-[1600px]:!w-[80%] flex-1">
                  <div className="border-b border-gray-200 pb-3">
                    <div className="mb-2 h-8 w-48 rounded skeleton-shimmer" />
                    <div className="mb-2 h-4 w-32 rounded skeleton-shimmer" />
                    <div className="flex items-center gap-1 mt-3">
                      <div className="h-5 w-5 rounded-full skeleton-shimmer" />
                      <div className="h-4 w-40 rounded skeleton-shimmer" />
                    </div>
                  </div>
                  <div className="mt-4 grid grid-cols-12 gap-3">
                    <div className="col-span-5">
                      <div className="mb-2 h-3 w-24 rounded skeleton-shimmer" />
                      <div className="h-4 w-32 rounded skeleton-shimmer" />
                    </div>
                    <div className="col-span-4 border-l border-gray-200 pl-3">
                      <div className="mb-2 h-3 w-20 rounded skeleton-shimmer" />
                      <div className="h-4 w-28 rounded skeleton-shimmer" />
                    </div>
                    <div className="col-span-3 border-l border-gray-200 pl-3">
                      <div className="mb-2 h-3 w-16 rounded skeleton-shimmer" />
                      <div className="h-4 w-24 rounded skeleton-shimmer" />
                    </div>
                  </div>
                  <div className="mt-5 h-10 w-full rounded-full skeleton-shimmer" />
                </div>
              </div>
            </div>

            {/* Mobile Skeleton Card 2 */}
            <div className="block md:hidden">
              <div className="relative rounded-[30px] border-2 border-gray-200 bg-white px-4 w-full h-max gap-4 overflow-hidden py-4">
                <div className="relative flex items-center gap-4">
                  <div className="relative w-[120px] h-[290px] flex-shrink-0 rounded-lg skeleton-shimmer" />
                  <div className="relative w-full flex-1">
                    <div className="border-b border-gray-200 pb-3 mb-4">
                      <div className="mb-2 h-7 w-40 rounded skeleton-shimmer" />
                      <div className="mb-2 h-3 w-28 rounded skeleton-shimmer" />
                      <div className="flex items-center gap-1 mt-2">
                        <div className="h-4 w-4 rounded-full skeleton-shimmer" />
                        <div className="h-3 w-32 rounded skeleton-shimmer" />
                      </div>
                    </div>
                    <div className="space-y-3">
                      <div>
                        <div className="mb-1 h-2 w-20 rounded skeleton-shimmer" />
                        <div className="h-3 w-28 rounded skeleton-shimmer" />
                      </div>
                      <div>
                        <div className="mb-1 h-2 w-16 rounded skeleton-shimmer" />
                        <div className="h-3 w-24 rounded skeleton-shimmer" />
                      </div>
                      <div>
                        <div className="mb-1 h-2 w-12 rounded skeleton-shimmer" />
                        <div className="h-3 w-20 rounded skeleton-shimmer" />
                      </div>
                    </div>
                    <div className="mt-4 h-9 w-full rounded-full skeleton-shimmer" />
                  </div>
                </div>
              </div>
            </div>

            {/* Skeleton Card 3 */}
            <div className="hidden md:block">
              <div className="relative rounded-[30px] border-2 border-gray-200 bg-white px-5 flex items-center w-full h-[300px] gap-4 overflow-hidden">
                <div className="relative w-[98px] md:w-[120px] xl:w-[98px] min-[1600px]:!w-[100px] h-[290px] flex items-start justify-start flex-col overflow-hidden rounded-lg skeleton-shimmer" />
                <div className="relative w-full xl:w-[400px] 2xl:w-[465px] min-[1600px]:!w-[80%] flex-1">
                  <div className="border-b border-gray-200 pb-3">
                    <div className="mb-2 h-8 w-48 rounded skeleton-shimmer" />
                    <div className="mb-2 h-4 w-32 rounded skeleton-shimmer" />
                    <div className="flex items-center gap-1 mt-3">
                      <div className="h-5 w-5 rounded-full skeleton-shimmer" />
                      <div className="h-4 w-40 rounded skeleton-shimmer" />
                    </div>
                  </div>
                  <div className="mt-4 grid grid-cols-12 gap-3">
                    <div className="col-span-5">
                      <div className="mb-2 h-3 w-24 rounded skeleton-shimmer" />
                      <div className="h-4 w-32 rounded skeleton-shimmer" />
                    </div>
                    <div className="col-span-4 border-l border-gray-200 pl-3">
                      <div className="mb-2 h-3 w-20 rounded skeleton-shimmer" />
                      <div className="h-4 w-28 rounded skeleton-shimmer" />
                    </div>
                    <div className="col-span-3 border-l border-gray-200 pl-3">
                      <div className="mb-2 h-3 w-16 rounded skeleton-shimmer" />
                      <div className="h-4 w-24 rounded skeleton-shimmer" />
                    </div>
                  </div>
                  <div className="mt-5 h-10 w-full rounded-full skeleton-shimmer" />
                </div>
              </div>
            </div>

            {/* Mobile Skeleton Card 3 */}
            <div className="block md:hidden">
              <div className="relative rounded-[30px] border-2 border-gray-200 bg-white px-4 w-full h-max gap-4 overflow-hidden py-4">
                <div className="relative flex items-center gap-4">
                  <div className="relative w-[120px] h-[290px] flex-shrink-0 rounded-lg skeleton-shimmer" />
                  <div className="relative w-full flex-1">
                    <div className="border-b border-gray-200 pb-3 mb-4">
                      <div className="mb-2 h-7 w-40 rounded skeleton-shimmer" />
                      <div className="mb-2 h-3 w-28 rounded skeleton-shimmer" />
                      <div className="flex items-center gap-1 mt-2">
                        <div className="h-4 w-4 rounded-full skeleton-shimmer" />
                        <div className="h-3 w-32 rounded skeleton-shimmer" />
                      </div>
                    </div>
                    <div className="space-y-3">
                      <div>
                        <div className="mb-1 h-2 w-20 rounded skeleton-shimmer" />
                        <div className="h-3 w-28 rounded skeleton-shimmer" />
                      </div>
                      <div>
                        <div className="mb-1 h-2 w-16 rounded skeleton-shimmer" />
                        <div className="h-3 w-24 rounded skeleton-shimmer" />
                      </div>
                      <div>
                        <div className="mb-1 h-2 w-12 rounded skeleton-shimmer" />
                        <div className="h-3 w-20 rounded skeleton-shimmer" />
                      </div>
                    </div>
                    <div className="mt-4 h-9 w-full rounded-full skeleton-shimmer" />
                  </div>
                </div>
              </div>
            </div>

            {/* Skeleton Card 4 */}
            <div className="hidden md:block">
              <div className="relative rounded-[30px] border-2 border-gray-200 bg-white px-5 flex items-center w-full h-[300px] gap-4 overflow-hidden">
                <div className="relative w-[98px] md:w-[120px] xl:w-[98px] min-[1600px]:!w-[100px] h-[290px] flex items-start justify-start flex-col overflow-hidden rounded-lg skeleton-shimmer" />
                <div className="relative w-full xl:w-[400px] 2xl:w-[465px] min-[1600px]:!w-[80%] flex-1">
                  <div className="border-b border-gray-200 pb-3">
                    <div className="mb-2 h-8 w-48 rounded skeleton-shimmer" />
                    <div className="mb-2 h-4 w-32 rounded skeleton-shimmer" />
                    <div className="flex items-center gap-1 mt-3">
                      <div className="h-5 w-5 rounded-full skeleton-shimmer" />
                      <div className="h-4 w-40 rounded skeleton-shimmer" />
                    </div>
                  </div>
                  <div className="mt-4 grid grid-cols-12 gap-3">
                    <div className="col-span-5">
                      <div className="mb-2 h-3 w-24 rounded skeleton-shimmer" />
                      <div className="h-4 w-32 rounded skeleton-shimmer" />
                    </div>
                    <div className="col-span-4 border-l border-gray-200 pl-3">
                      <div className="mb-2 h-3 w-20 rounded skeleton-shimmer" />
                      <div className="h-4 w-28 rounded skeleton-shimmer" />
                    </div>
                    <div className="col-span-3 border-l border-gray-200 pl-3">
                      <div className="mb-2 h-3 w-16 rounded skeleton-shimmer" />
                      <div className="h-4 w-24 rounded skeleton-shimmer" />
                    </div>
                  </div>
                  <div className="mt-5 h-10 w-full rounded-full skeleton-shimmer" />
                </div>
              </div>
            </div>

            {/* Mobile Skeleton Card 4 */}
            <div className="block md:hidden">
              <div className="relative rounded-[30px] border-2 border-gray-200 bg-white px-4 w-full h-max gap-4 overflow-hidden py-4">
                <div className="relative flex items-center gap-4">
                  <div className="relative w-[120px] h-[290px] flex-shrink-0 rounded-lg skeleton-shimmer" />
                  <div className="relative w-full flex-1">
                    <div className="border-b border-gray-200 pb-3 mb-4">
                      <div className="mb-2 h-7 w-40 rounded skeleton-shimmer" />
                      <div className="mb-2 h-3 w-28 rounded skeleton-shimmer" />
                      <div className="flex items-center gap-1 mt-2">
                        <div className="h-4 w-4 rounded-full skeleton-shimmer" />
                        <div className="h-3 w-32 rounded skeleton-shimmer" />
                      </div>
                    </div>
                    <div className="space-y-3">
                      <div>
                        <div className="mb-1 h-2 w-20 rounded skeleton-shimmer" />
                        <div className="h-3 w-28 rounded skeleton-shimmer" />
                      </div>
                      <div>
                        <div className="mb-1 h-2 w-16 rounded skeleton-shimmer" />
                        <div className="h-3 w-24 rounded skeleton-shimmer" />
                      </div>
                      <div>
                        <div className="mb-1 h-2 w-12 rounded skeleton-shimmer" />
                        <div className="h-3 w-20 rounded skeleton-shimmer" />
                      </div>
                    </div>
                    <div className="mt-4 h-9 w-full rounded-full skeleton-shimmer" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </>
    );
}
